import { useEntityEvent } from "./useEntityEvent.js";
const useOnConnectionUpdate = (fieldName, listener) => {
  useEntityEvent("connectionUpdate", fieldName, listener);
};
export {
  useOnConnectionUpdate
};
//# sourceMappingURL=useOnConnectionUpdate.js.map
